"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { AuthContext } from "@/components/auth/Auth";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiAvailableRatingCredit } from "@/generated/models/ApiAvailableRatingCredit";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function GroupCardActionStats(t0) {
  const $ = _c(42);
  const {
    matter,
    membersCount,
    loadingMembersCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiRateMatter.Rep]: "Rep",
      [ApiRateMatter.Cic]: "Nic"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const MATTER_LABEL = t1;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const [rater, setRater] = useState(null);
  const [raterRepresentative, setRaterRepresentative] = useState(null);
  const [creditPerMember, setCreditPerMember] = useState(0);
  let t2;
  let t3;
  if ($[1] !== activeProfileProxy || $[2] !== connectedProfile) {
    t2 = () => {
      if (!connectedProfile?.handle) {
        setRater(null);
        setRaterRepresentative(null);
        return;
      }
      if (activeProfileProxy) {
        setRater(activeProfileProxy.created_by.handle);
        setRaterRepresentative(connectedProfile.handle);
        return;
      }
      setRater(connectedProfile.handle);
      setRaterRepresentative(null);
    };
    t3 = [connectedProfile, activeProfileProxy];
    $[1] = activeProfileProxy;
    $[2] = connectedProfile;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== rater || $[6] !== raterRepresentative) {
    t4 = [QueryKey.IDENTITY_AVAILABLE_CREDIT, {
      rater,
      rater_representative: raterRepresentative
    }];
    t5 = async () => {
      if (!rater) {
        return null;
      }
      const params = {
        rater
      };
      if (raterRepresentative) {
        params.rater_representative = raterRepresentative;
      }
      return await commonApiFetch({
        endpoint: "ratings/credit",
        params
      });
    };
    $[5] = rater;
    $[6] = raterRepresentative;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const t6 = !!rater;
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      placeholderData: keepPreviousData,
      enabled: t6
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const {
    data: creditLeft
  } = useQuery(t7);
  let t8;
  if ($[13] !== creditLeft?.cic_credit || $[14] !== creditLeft?.rep_credit || $[15] !== matter) {
    t8 = () => {
      switch (matter) {
        case ApiRateMatter.Rep:
          {
            return creditLeft?.rep_credit ?? null;
          }
        case ApiRateMatter.Cic:
          {
            return creditLeft?.cic_credit ?? null;
          }
        default:
          {
            assertUnreachable(matter);
            return null;
          }
      }
    };
    $[13] = creditLeft?.cic_credit;
    $[14] = creditLeft?.rep_credit;
    $[15] = matter;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const getCreditLeft = t8;
  let t9;
  if ($[17] !== getCreditLeft || $[18] !== membersCount) {
    t9 = () => {
      const credit = getCreditLeft();
      if (typeof credit === "number" && typeof membersCount === "number" && credit > 0 && membersCount > 0) {
        const creditPerMember_0 = credit / membersCount;
        setCreditPerMember(creditPerMember_0);
      } else {
        setCreditPerMember(0);
      }
    };
    $[17] = getCreditLeft;
    $[18] = membersCount;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== creditLeft || $[21] !== membersCount) {
    t10 = [creditLeft, membersCount];
    $[20] = creditLeft;
    $[21] = membersCount;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t9, t10);
  let t11;
  if ($[23] !== membersCount) {
    t11 = typeof membersCount === "number" ? formatNumberWithCommas(membersCount) : null;
    $[23] = membersCount;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const count = t11;
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <img src="/pepe-xglasses.png" className="-tw-mt-0.5 tw-w-4 tw-h-4 tw-ml-1 tw-mr-1.5 tw-object-contain tw-flex-shrink-0 tw-inline" alt="pepe-xglasses" />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = creditPerMember > 0 && "+-";
  let t14;
  if ($[26] !== creditPerMember) {
    t14 = creditPerMember.toFixed(0);
    $[26] = creditPerMember;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = +t14;
  let t16;
  if ($[28] !== t15) {
    t16 = formatNumberWithCommas(t15);
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t13 || $[31] !== t16) {
    t17 = <span className="tw-text-primary-400 tw-font-semibold">{t13}{t16}</span>;
    $[30] = t13;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = MATTER_LABEL[matter];
  let t19;
  if ($[33] !== count || $[34] !== loadingMembersCount) {
    t19 = loadingMembersCount ? <CircleLoader size={CircleLoaderSize.SMALL} /> : count;
    $[33] = count;
    $[34] = loadingMembersCount;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t19) {
    t20 = <span><span className="tw-text-primary-400 tw-font-semibold">{" "}{t19}</span>{" "}members of the group.</span>;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== t20) {
    t21 = <div className="tw-mt-4"><p className="tw-text-sm tw-block tw-mb-0 tw-text-iron-50 tw-font-medium">{t12}You can grant up to{" "}{t17}{" "}{t18} to each of{t20}</p></div>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
}